import React from "react"
import {compose} from "redux"
import {useTranslation} from "react-i18next"
import {Box, Button, Icon} from "@material-ui/core"

// HOCs
import withConclusion, {WithConclusionProps} from "../../hoc/withConclusion"
import withApproveDialog, {WithApproveDialogProps} from "../../hoc/withApproveDialog"

// Components
import ApproveDialog from "../ApproveDialog"

// Styles
import useStyles from "./styles"

/**
 * @param props
 */
function ApproveSection(props: WithApproveDialogProps & WithConclusionProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");

    return (
        <Box component="section" className={styles.container}>
            <ApproveDialog/>
            <Button color="primary"
                    variant="contained"
                    disabled={props.isConclusionEditing || props.isParameterEditing}
                    className={styles.button}
                    onClick={() => props.setApproveDialogActive(true)}>
                {t("approve")}
            </Button>
        </Box>
    )
}

export default compose(
    withApproveDialog,
    withConclusion,
)
(ApproveSection)
